module.exports = __webpack_public_path__ + "media/images/desktop/document-5d85746a99ce5cf162dd6238f7d74866.svg";